import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logo2 from '../assets/img/logo/logo2.png'
import logo_mobile from '../assets/img/logo/logo-mobile.png'
import Footer from './common/Footer'
import axios from 'axios'
import * as Constants from "../Constants/index"
import swal from 'sweetalert'
import "./PRDASSOCIATE.css"

export default function PRDASSOCIATE() {

    const [mobile, setMobile] = useState('')
    const [otp, setOtp] = useState('')
    const [errors, setErrors] = useState({})
    const [showOtpModal, setShowOtpModal] = useState(false)

    // ================= VALIDATION =================
    const validateForm = () => {
        let errors = {}
        if (!mobile) errors.mobile = 'Mobile No. is required'
        else if (!/^\d+$/.test(mobile)) errors.mobile = 'Only numbers allowed'
        else if (mobile.length !== 10) errors.mobile = 'Mobile must be 10 digits'
        return errors
    }

    // ================= SEND OTP =================
    const handleSubmit = async () => {
        setErrors({})
        const validationErrors = validateForm()

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors)
            return
        }

        try {
            const res = await axios.post(
                Constants.baseUrl + 'auth/login-otp',
                { mobile, password: '' },
                {
                    headers: {
                        appVersion: Constants.av,
                        platform: Constants.pt,
                        company: Constants.company,
                        program: Constants.program,
                    }
                }
            )

            if (res.data.code === 16001) {
                swal("Success", res.data.msg, "success")
                setShowOtpModal(true)
            } else {
                swal("Error", res.data.msg, "error")
            }

        } catch (error) {
            console.log(error)
        }
    }

    // ================= VERIFY OTP =================
    const verifyOtp = async () => {
        if (!otp || otp.length !== 4) {
            swal("Error", "Enter valid OTP", "error")
            return
        }

        try {
            const res = await axios.post(
                Constants.baseUrl + 'auth/verify-otp',
                { mobile, otp },
                {
                    headers: {
                        appVersion: Constants.av,
                        platform: Constants.pt,
                        company: Constants.company,
                        program: Constants.program,
                    }
                }
            )

            if (res.data.code === 10001) {
                swal("Success", "Login Successful", "success")
                // console.log("sesss===>", res.data?.output?.user?.id)
               localStorage.setItem("user_id", res.data.output.user.id);
              localStorage.setItem("user_type", res.data.output.user.userType);
              localStorage.setItem("user_name", res.data.output.user.name);
              localStorage.setItem("user_email", res.data.output.user.email);
              localStorage.setItem("user_mobile", res.data.output.user.mobile);
              localStorage.setItem("token", res.data.output.access.token);
                setTimeout(() => {
                    window.location.href = "/dashboard"
                }, 1500)
                setOtp('')
                setShowOtpModal(false)
            } else {
                swal("Error", res.data.msg, "error")
            }

        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            {/* ================= HEADER ================= */}
            <header>
                <div className="header-container header-sticky sticky header-nav">
                    <div className="header-top-area">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-4 col-sm-4 col-xs-12">
                                    <div className="header-top-menu text-left">
                                        <ul>
                                            <li className="">
                                                <Link to="mailto:info@hafelecup.in">
                                                    <i className="fa fa-envelope-o"></i> info@hafelecup.in
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-8 col-sm-8  text-right">
                                    <div className="header-top-menu">
                                        <ul>
                                            <li className="support"><Link to="tel:+919289422000"><i className="fa fa-phone"></i> +91 9289422000 </Link></li>
                                            <li className="support hidden-xs"><span> <i className="fa fa-clock-o"></i> 09:30 AM to 05:30 PM </span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="header-middel-area hidden-xs">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-2 col-sm-2 col-xs-6">
                                    <div className="logo logo1">
                                        <Link to="#"><img src={logo2} alt="" /></Link>
                                    </div>
                                </div>
                                <div className="col-md-10 col-sm-10 col-xs-12 hidden-xs">
                                    <div className="main-menu-area">
                                        <nav>
                                            <ul className="main-menu">
                                                <li><Link to="/" >Home</Link></li>

                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mobile-menu-area hidden-sm hidden-md hidden-lg">
                        <div className="container">
                            <div className="row">
                                <div className="mobile_logo">
                                    <Link to="#"><img src={logo_mobile} alt="" /></Link>
                                </div>
                                <div className="col-xs-12">
                                    <div className="mobile-menu">
                                        <nav>
                                            <ul>
                                                <li><Link to="/" >Home</Link></li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            {/* ================= LOGIN ================= */}
            <section className="blog-area min370">
                <div className="container">
                    <div className="user_card">

                        <h4 className="text-center mb-3">PRD - ASSOCIATE LOGIN</h4>

                        <input
                            className="form-control"
                            placeholder="Enter Mobile Number"
                            maxLength="10"
                            value={mobile}
                            onChange={(e) => {
                                if (/^\d*$/.test(e.target.value)) {
                                    setMobile(e.target.value)
                                }
                            }}
                        />

                        {errors.mobile && (
                            <div className="error-message">{errors.mobile}</div>
                        )}

                        <button
                            className="btn btn-danger w-100 mt-3"
                            onClick={handleSubmit}
                        >
                            Send OTP
                        </button>
                    </div>
                </div>
            </section>

            {/* ================= CUSTOM OTP MODAL ================= */}
            {showOtpModal && (
                <div className="custom-modal-overlay">
                    <div className="custom-modal">
                        <span
                            className="close-btn"
                            onClick={() => setShowOtpModal(false)}
                        >
                            ×
                        </span>

                        <h4 className="text-center mb-3">Enter OTP</h4>

                        <input
                            type="text"
                            maxLength="4"
                            className="form-control"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                        />

                        <button
                            className="btn btn-danger w-100 mt-3"
                            onClick={verifyOtp}
                        >
                            Verify OTP
                        </button>
                    </div>
                </div>
            )}

            <Footer />
        </>
    )
}
